import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-437ca958"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "relative text-gray-700 antialiased text-sm font-semibold"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hidden sm:block border-l-2 border-gray-500 absolute h-full left-1/2 transform -translate-x-1/2 dotted-line" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "sm:hidden border-l-2 border-gray-500 absolute h-full right-3 transform dotted-line",
  style: {"--tw-translate-x":"-1px"}
}, null, -1))
const _hoisted_4 = { class: "flex flex-col sm:flex-row items-center" }
const _hoisted_5 = {
  key: 0,
  class: "flex justify-start w-full mx-auto items-center"
}
const _hoisted_6 = { class: "w-full sm:w-1/2 sm:pr-8" }
const _hoisted_7 = { class: "rounded-xl bg-gray-100 p-4 flex gap-4" }
const _hoisted_8 = { class: "pl-3 border-l-2 border-gray-500" }
const _hoisted_9 = {
  key: 1,
  class: "flex justify-end w-full mx-auto items-center"
}
const _hoisted_10 = { class: "w-full sm:w-1/2 sm:pl-8" }
const _hoisted_11 = { class: "rounded-xl bg-gray-100 p-4 flex gap-4" }
const _hoisted_12 = { class: "pl-3 border-l-2 border-gray-500" }

import { toRefs, computed } from 'vue'
import { formatDate } from '@/utils/helpers/parseDate'
import environment from '@/configs/environtment'
import type { PropType } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Logger',
  props: {
  items: {
    type: Array as PropType<any[]>,
    default: () => [],
    required: true
  }
},
  setup(__props) {

const props = __props



const isProduction = computed(() => environment.getMode() === 'production')

const { items } = toRefs(props)


return (_ctx: any,_cache: any) => {
  return (_unref(items).length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(items), (data, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "mt-6 sm:mt-0 sm:mb-12"
          }, [
            _createElementVNode("div", _hoisted_4, [
              (index % 2 === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", null, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["text-base font-bold", _unref(isProduction) ? 'text-primary-700' : 'text-secondary-700'])
                          }, _toDisplayString(_unref(formatDate)(data?.createdDate, 'MMMM')), 3),
                          _createElementVNode("div", {
                            class: _normalizeClass(["text-3xl font-bold", _unref(isProduction) ? 'text-primary-700' : 'text-secondary-700'])
                          }, _toDisplayString(_unref(formatDate)(data?.createdDate, 'DD')), 3)
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["text-base font-bold", _unref(isProduction) ? 'text-primary-700' : 'text-secondary-700'])
                          }, _toDisplayString(data?.status), 3),
                          _createElementVNode("div", null, _toDisplayString(data?.description), 1),
                          _createElementVNode("div", null, _toDisplayString(`Pada ${_unref(formatDate)(data?.createdDate, 'DD MMMM YYYY')} - ${_unref(formatDate)(data?.createdDate, 'HH.mm')}`) + " WIB", 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass([_unref(isProduction) ? 'bg-primary-700' : 'bg-secondary-700', "rounded-full border-white border-4 w-8 h-8 sm:absolute sm:left-1/2 sm:-translate-x-1/2 sm:-translate-y-1/2 -right-4 transform flex items-center justify-center"])
                    }, null, 2)
                  ]))
                : _createCommentVNode("", true),
              (index % 2 !== 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", null, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["text-base font-bold", _unref(isProduction) ? 'text-primary-700' : 'text-secondary-700'])
                          }, _toDisplayString(_unref(formatDate)(data?.createdDate, 'MMMM')), 3),
                          _createElementVNode("div", {
                            class: _normalizeClass(["text-3xl font-bold", _unref(isProduction) ? 'text-primary-700' : 'text-secondary-700'])
                          }, _toDisplayString(_unref(formatDate)(data?.createdDate, 'DD')), 3)
                        ]),
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["text-base font-bold", _unref(isProduction) ? 'text-primary-700' : 'text-secondary-700'])
                          }, _toDisplayString(data?.status), 3),
                          _createElementVNode("div", null, _toDisplayString(data?.description), 1),
                          _createElementVNode("div", null, _toDisplayString(`Pada ${_unref(formatDate)(data?.createdDate, 'DD MMMM YYYY')} - ${_unref(formatDate)(data?.createdDate, 'HH.mm')}`) + " WIB", 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass([_unref(isProduction) ? 'bg-primary-700' : 'bg-secondary-700', "rounded-full border-white border-4 w-8 h-8 sm:absolute sm:left-1/2 sm:-translate-x-1/2 sm:-translate-y-1/2 -right-4 transform flex items-center justify-center"])
                    }, null, 2)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})